module.exports = __webpack_public_path__ + "img/gm.fd9854cb.svg";